import React from 'react'
import { Link } from 'react-router-dom'
import ShopOwner from './ShopOwnerAdd'

class ShopOwnerAddingTab extends React.Component {
  state = {}
  componentDidMount() {
    if (
      this.props.match.params.shopOwner_ids !== undefined &&
      this.props.match.params.shopOwner_ids !== null &&
      this.props.match.params.shopOwner_ids !== 0 &&
      this.props.match.params.shopOwner_ids !== ''
    ) {
      this.setState({ shopOwner_ids: this.props.match.params.shopOwner_ids })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.shopOwner_ids ? 'Edit' : 'Add'} Shop Owner</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/shop-owner">Shop Owner List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.shopOwner_ids ? 'Edit' : 'Add'} Shop Owner
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'add_dealer_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.shopOwner_ids !== undefined &&
                        this.state.shopOwner_ids !== null &&
                        this.state.shopOwner_ids !== 0 &&
                        this.state.shopOwner_ids !== '' ? (
                          <ShopOwner
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            shopOwner_ids={this.state.shopOwner_ids}
                          />
                        ) : (
                          <ShopOwner
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ShopOwnerAddingTab
